const routes = {
    '/': () => import('./modules/index.js')
};

export class Router {
    constructor(containerId) {
        this.containerId = containerId;
        this.container = null;
        
        // Inicializar eventos
        this.init();
    }

    init() {
        window.addEventListener('popstate', () => this.handleRoute());

        document.addEventListener('click', (e) => {
            const link = e.target.closest('[data-link]');
            if (link) {
                e.preventDefault();
                this.navigateTo(link.getAttribute('href'));
            }
        });

        // Intentar procesar la ruta inicial
        this.handleRoute();
    }

    navigateTo(url) {
        window.history.pushState(null, null, url);
        this.handleRoute();
    }



async handleRoute() {
    let path = window.location.pathname;

    // 1. Limpiamos la barra final si existe
    if (path.endsWith('/') && path.length > 1) {
        path = path.slice(0, -1);
    }

    // 2. Buscamos el módulo correspondiente a la URL actual primero
    const loadModule = routes[path] || routes['/Dashboard/404'];

    if (!loadModule) {
        console.error(`Ruta no definida y sin respaldo 404: ${path}`);
        return;
    }

    try {
        // 3. Importamos el JS del módulo de manera dinámica (aquí ya sabe si es login, index, etc.)
        const module = await loadModule();
        
        if (module.default) {
            
            // 4. Buscamos el contenedor por si este módulo en específico lo necesita
            this.container = document.getElementById(this.containerId);
            
            if (!this.container) {
                // CASO A: Es una vista nativa de PHP (como Login o Register)
                // Ejecutamos su JS pasándole null, porque el HTML ya existe en el DOM
                console.log(`Ejecutando módulo de forma directa en vista PHP para: ${path}`);
                module.default(null); 
            } else {
                // CASO B: Es el Dashboard SPA dinámico
                // Limpiamos el contenedor e inyectamos/inicializamos
                this.container.innerHTML = ''; 
                module.default(this.container);
            }
        }
    } catch (error) {
        console.error(`Error cargando la ruta ${path}:`, error);
        if (this.container) {
            this.container.innerHTML = `<p>Error al cargar el panel.</p>`;
        }
    }
}




}